import React from "react"
import { Typography } from "antd"

import Image from "next/image"
import { useTranslation } from "react-i18next"

interface InvitationTitleProps {
  orgName: string
}

const { Title } = Typography
const InvitationTitle: React.FC<InvitationTitleProps> = ({ orgName }) => {
  const { t } = useTranslation()
  return (
    <div className="text-center pt-5 mb-8">
      <Image
        className="cursor-pointer"
        src="/assets/images/logo.svg"
        alt="logo"
        priority={true}
        width={60}
        height={60}
      />
      <Title level={3}>{t("invitation.joinKosmo")}</Title>
      <p className="text-gray-500 text-lg">
        {t("invitation.welcomeMessage", { orgName: orgName })}
      </p>
    </div>
  )
}

export default InvitationTitle
